














import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {
        NavigationHeaderView: () => import(
            /* webpackChunkName: "NavigationHeaderView" */
            '@/views/NavigationHeader.view.vue')
    }
})
export default class App extends Vue {

    public showAppBar: boolean = false;

    @Watch('$route')
    private onRouteChange() {
        this.showAppBar = !['code_view'].includes(this.$route.name!);
    }

    constructor() {
        super();
        console.info('using referrer: ', document.referrer);
        console.info(`%cclient version: ${process.env.VUE_APP_VERSION}`, 'font-weight: bold');
    }

    public async mounted() {
        // The inner height is the space between the navigation- and bottom bar (from the browser)
        function resetHeight() {
            document.body.style.height = window.innerHeight + 'px';
        }

        window.addEventListener('resize', resetHeight); // Set the height whenever the screen is resized
        resetHeight();
    }
}
